import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import Corsi from "./pages/Corsi";
import Insegnanti from "./pages/Insegnanti";
import Eventi from "./pages/Eventi";
import Masterclass from "./pages/Masterclass";
import Progetti from "./pages/Progetti";
import ProgettoDetail from "./pages/ProgettoDetail";
import Galleria from "./pages/Galleria";
import Reels from "./pages/Reels";
import Certificazioni from "./pages/Certificazioni";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Iscrizione from "./pages/Iscrizione";
import Sostienici from "./pages/Sostienici";
import Teatro from "./pages/Teatro";
import AreaSoci from "./pages/AreaSoci";
import Contatti from "./pages/Contatti";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <main data-testid="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/corsi" element={<Corsi />} />
            <Route path="/insegnanti" element={<Insegnanti />} />
            <Route path="/eventi" element={<Eventi />} />
            <Route path="/masterclass" element={<Masterclass />} />
            <Route path="/progetti" element={<Progetti />} />
            <Route path="/progetti/:id" element={<ProgettoDetail />} />
            <Route path="/galleria" element={<Galleria />} />
            <Route path="/reels" element={<Reels />} />
            <Route path="/certificazioni" element={<Certificazioni />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/iscrizione" element={<Iscrizione />} />
            <Route path="/sostienici" element={<Sostienici />} />
            <Route path="/teatro" element={<Teatro />} />
            <Route path="/area-soci" element={<AreaSoci />} />
            <Route path="/contatti" element={<Contatti />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
